import moment from 'moment';
import React, { Component } from 'react';
import { Form, Input, Label } from 'reactstrap';

class TimeSelector extends Component {
  constructor(props) {
    super(props);
    const date = moment(this.props.date);

    this.state = {
      properties: {
        hours: date.hours() > 12? date.hours() - 12: date.hours(),
        meridiem: date.hours() < 12 ? 'am' : 'pm',
        minutes: Math.ceil(date.minutes() / 15) * 15,
      },
    };
  }

  // ----------------------
  // Render
  // ----------------------

  componentDidMount() {
    // Must trigger event to sync parent data to minutes value calculated
    //   in constructor
    this.triggerOnChange();
  }

  // ----------------------
  // Methods
  // ----------------------

  handleChange(name, value) {
    const updatedValue = name === 'meridiem' ? value : parseInt(value, 10);
    this.setState(
      state => ({ properties: { ...state.properties, [name]: updatedValue } }),
      () => this.triggerOnChange(),
    );
  }

  triggerOnChange() {
    const hours = this.state.properties.meridiem === 'am'
      ? this.state.properties.hours : this.state.properties.hours + 12;
    const date = moment().hours(hours)
      .minutes(this.state.properties.minutes);
    this.props.onChange(date.toISOString());
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <div className="form-inline" name="timeSelector">
        <Input
          className="form-control"
          name="hours"
          onChange={event => this.handleChange(event.target.name, parseInt(event.target.value, 10))}
          type="select"
          value={this.state.properties.hours}
        >
          <option value={0}>12</option>
          <option value={1}>1</option>
          <option value={2}>2</option>
          <option value={3}>3</option>
          <option value={4}>4</option>
          <option value={5}>5</option>
          <option value={6}>6</option>
          <option value={7}>7</option>
          <option value={8}>8</option>
          <option value={9}>9</option>
          <option value={10}>10</option>
          <option value={11}>11</option>
        </Input>
        <Input
          className="form-control"
          name="minutes"
          onChange={event => this.handleChange(event.target.name, parseInt(event.target.value, 10))}
          type="select"
          value={this.state.properties.minutes}
        >
          <option value="00">00</option>
          <option value="15">15</option>
          <option value="30">30</option>
          <option value="45">45</option>
        </Input>
        <Input
          className="form-control"
          name="meridiem"
          onChange={event => this.handleChange(event.target.name, event.target.value)}
          type="select"
          value={this.state.properties.meridiem}
        >
          <option value="am">am</option>
          <option value="pm">pm</option>
        </Input>
      </div>
    );
  }
}

export default TimeSelector;
